import type { Site } from '@hotjar/site';
import type { IconSetDefinitions } from '@hotjar/hotsauce/build/components/Icon/icons';

export interface StepProps {
  disabled?: boolean;
  onInstallClick: () => void;
  onButtonClick: () => void;
}

export enum StepId {
  FinishInstallation = 'Finish Installation',
  Welcome = 'Welcome to Hotjar',
  Invite = 'Invite',
  Recording = 'View Recording',
  Heatmap = 'View Heatmap',
  RecordingHeatmap = 'View Recording and Heatmap',
  Feedback = 'Feedback',
  Survey = 'Launch Survey',
  Highlights = 'View Highlights',
  Integrations = 'View Integrations',
  Segments = 'Segments',
  LocalFilters = 'Filters',
  GlobalFilters = 'View Filters',
}

export enum StepState {
  Success = 'success',
  Skipped = 'skipped',
  Pending = 'pending',
}

export interface GettingStartedGuideState {
  enabled: boolean;
  hasLoaded: boolean;
  site?: Site;
  trackingCodeInstalled?: boolean | string;
  welcomeVideoSeen?: boolean | string;
  spacesStepCompleted?: boolean | string;
  inviteSkipped?: boolean | string;
  isSpaceEnabled?: boolean | string;
  isInviteEnabled?: boolean | string;
  inviteCompleted?: boolean | string;
  tipsLeft?: number | string;
  isCelebrated?: boolean;
  recordingViewed?: boolean | string;
  heatmapViewed?: boolean | string;
  incomingFeedbackCreated?: boolean | string;
  surveyLaunched?: boolean | string;
  isFeedbackEnabled?: boolean | string;
  isHighlightsViewed?: boolean | string;
  isIntegrationsViewed?: boolean | string;
  isSegmentsViewed?: boolean | string;
  isLocalFiltersViewed?: boolean | string;
  isGlobalFiltersViewed?: boolean | string;
}

export interface CTA {
  title: string;
  icon?: keyof IconSetDefinitions | undefined;
  query?: string;
  url?: string;
  isExternal?: boolean;
  completeOnClick?: boolean;
}

export interface Step {
  id: StepId;
  state: StepState;
  title: string;
  subtitle: string;
  content?: string;
  cta?: CTA;
  ctaIcon?: keyof IconSetDefinitions | undefined;
  ctaSecondary?: CTA;
  icon?: keyof IconSetDefinitions | undefined;
  path?: string;
  url?: string;
  banner?: string;
}
